import { __decorate, __metadata } from "tslib";
import { Component, Prop, Ref } from "vue-property-decorator";
import { UIComponent } from "../UIComponent";
import * as Popper from "@popperjs/core";
export const COMPONENT_NAME = "LvControlPopover";
/**
 * A component to link an element with a popover
 */
let LvControlPopover = class LvControlPopover extends UIComponent {
    constructor() {
        super(...arguments);
        this.visible = false;
        this.popperInstance = null;
        this.clickHandler = this.onDocumentClick.bind(this);
    }
    beforeDestroy() {
        if (this.autoClose) {
            document.removeEventListener("click", this.clickHandler);
        }
        this.destroyPopperInstance();
    }
    onDocumentClick(e) {
        if (e.target != this.$el && !this.$el.contains(e.target))
            this.hide();
    }
    createPopperInstance() {
        if (this.popperInstance == null) {
            this.popperInstance = Popper.createPopper(this.control, this.popover, {
                placement: "bottom-start",
                modifiers: [
                    {
                        name: "flip",
                        enabled: true,
                    },
                ],
            });
        }
    }
    destroyPopperInstance() {
        if (this.popperInstance != null) {
            this.popperInstance.destroy();
            this.popperInstance = null;
        }
    }
    /**
     * Show the popover
     */
    show() {
        this.visible = true;
        if (this.autoClose) {
            document.addEventListener("click", this.clickHandler);
        }
        this.$nextTick(() => this.createPopperInstance());
    }
    /**
     * Hide the popover
     */
    hide() {
        this.visible = false;
        if (this.autoClose) {
            document.removeEventListener("click", this.clickHandler);
        }
        this.destroyPopperInstance();
    }
    /**
     * Show or hide the popover
     */
    toggle() {
        if (this.visible)
            this.hide();
        else
            this.show();
    }
};
__decorate([
    Prop({ type: Boolean, required: false, default: true }),
    __metadata("design:type", Boolean)
], LvControlPopover.prototype, "autoClose", void 0);
__decorate([
    Ref(),
    __metadata("design:type", HTMLDivElement)
], LvControlPopover.prototype, "control", void 0);
__decorate([
    Ref(),
    __metadata("design:type", HTMLDivElement)
], LvControlPopover.prototype, "popover", void 0);
LvControlPopover = __decorate([
    Component({
        name: COMPONENT_NAME,
    })
], LvControlPopover);
export default LvControlPopover;
//# sourceMappingURL=script.js.map